<template>
    <section>
        <div class="courses" :style="{ backgroundImage: `url(https://kw-lp-info.s3-eu-west-1.amazonaws.com/eFuturo/courses/${$route.params.course}/hero.jpg)` }">
            <div class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 lg:tw-container">
                <div class="hero-mobile tw-relative" :style="{ backgroundImage: `url(https://kw-lp-info.s3-eu-west-1.amazonaws.com/eFuturo/courses/${$route.params.course}/hero.jpg)` }">
                    <h2>{{$store.state.courseInfo.humanFriendlyName}}</h2>
                    <div class="price">
                        <p class="tw-pt-4">DESDE</p>
                        <p class="strong">{{ $store.state.courseInfo.value }}<span>€</span></p>
                        <p>MÊS</p>
                    </div>
                    <!-- <img class="dgert" src="~@/assets/img/logo_dgert.svg" alt="Certificado DGERT"> -->
                </div>
                <div class="">
                    <Form v-if="!$store.state.formSuccess" />
                    <FormSuccess v-if="$store.state.formSuccess" >
                    </FormSuccess>
                </div>
            </div>
        </div>
        <div class="course-info">
            <div class="lg:tw-container tw-grid tw-grid-cols-1 tw-gap-5 lg:tw-grid-cols-2 lg:tw-gap-10">
                <div class="cards tw-relative">
                    <h2> Objectivos deste curso </h2>
                    <ul>
                        <li v-for="objectivos in $store.state.courseInfo.objectivosDesteCurso" :key="objectivos">
                            {{ objectivos }}
                        </li>
                    </ul>
                </div>
                <div class="cards tw-relative">
                    <h2> Saídas Profissionais:</h2>
                    <ul>
                        <li v-for="saida in $store.state.courseInfo.saidasProfissionais" :key="saida">
                            {{ saida }}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="sponsors tw-container tw-items-center md:tw-flex md:tw-justify-evenly">
            <div class="" v-for="sponsor in $store.state.courseInfo.sponsors" :key="sponsor" >
                <img :src="`https://kw-lp-info.s3-eu-west-1.amazonaws.com/eFuturo/brands/${sponsor}`">
            </div>
        </div>
        <div class="nav">
            <div class="tw-container tw-text-center">
                <button
                    type="button"
                    class="btn-nav"
                    id="nav"
                    @click="$helpers.ScrollTo('form')"
                >
                    Fale Connosco
                </button>
            </div>
        </div>
    </section>
</template>
<script>
import Form from '@/components/Form.vue';
import FormSuccess from '@/components/FormSuccess.vue';

export default {
    name: 'Course',
    components: {
        Form,
        FormSuccess,
    },
    methods: {
        scrollTo(target) {
            document.querySelector(`${target}`).scrollIntoView({
                behavior: 'smooth',
            });
        },
        redirectToCourse() {
            this.$router.push({ path: `/${slugify(this.course).toLowerCase()}` });
        },
    },
    mounted() {
        axios
            .get(`https://kw-lp-info.s3-eu-west-1.amazonaws.com/eFuturo/courses/${this.$route.params.course}/info.json`)
            .then((response) => {
                this.$store.state.courseInfo = response.data;
                this.$store.state.course = response.data.code;
                console.log(response.data);
            })
            .catch(() => {
                this.$router.push('/');
            });
    },
};
</script>
<style lang="scss">
@import '@/assets/scss/course.scss';

</style>

};
